import Vue from 'vue';
import App from './App';
import {router} from './router';
import {Loading, Button, Form, Field, Picker, Popup, Icon,Toast,Switch,Dialog,RadioGroup,Radio,Image as VanImage, Empty, Slider } from 'vant';

Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(VanImage);
Vue.use(Empty);
Vue.use(Slider);

new Vue({
    router,
    el: '#app',
    render: h => h(App)
});
